(function () {
	'use strict';

	const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
	const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
	const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

	/**
	 * Manages the visibility state of elements as they enter or leave the viewport.
	 * 
	 * @param {IntersectionObserverEntry[]} elements - Array of intersection observer entries.
	 * @param {IntersectionObserver} observer - The observer instance.
	 * 
	 * @returns {void}
	 */
	function onIntersection(elements, observer) {
		elements.forEach((element) => {
			if (element.isIntersecting) {
				const elementTarget = element.target;

				if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
					element.target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
				}

				observer.unobserve(elementTarget);
			} else {
				element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
				element.target.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
			}
		});
	}

	/**
	 * Sets up an IntersectionObserver to watch for elements entering the viewport.
	 * 
	 * @returns {void}
	 */
	function init() {
		// Find all animations that should have scroll animations
		// and are not marked with data-no-animation.
		const scrollTriggers = Array.from(document.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`)).filter(
			(el) => !el.closest('[data-no-animation]'),
		);

		// Bail early if there are no scroll triggers.
		if (!scrollTriggers.length) return;

		// Watch for elements entering the viewport.
		const observer = new IntersectionObserver(onIntersection, {
			rootMargin: '0px 0px -50px 0px',
		});

		// Observe the scroll triggers.
		scrollTriggers.forEach((trigger) => observer.observe(trigger));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => init());
	} else {
		init();
	}
})();